import React from "react";
import { useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import AccountingRPT from "./accountingRPT";
import { convertToTreeData } from "../../../../services/accountIndex-services";
import AccountMovement from "../AccountsReport/AccountMovement";
import AccountMovements from "../AccountsMovement/AccountsMovement";

const defaultAutos = {
  Safes: [],
};

export default function AccountingRPTCon() {
  const tb = {
    wait: true,
    Branches: true,
    costcenters: true,
    AccountsIndex: true,
    multiData: true,
    omlat: true,
    stor: sto,
    parms: { safe: -1,db_name:sto.db_name },
  };
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb
  );
  // let Urls = null;
  // if (sto.db_name === "" || sto.db_name === null) {
  //   Urls = "accounts-index/getAll"
  // } else { 
  //   Urls = `accounts-index/getAll?db_name=${sto?.db_name}`
  // }
  // const url = uri + Urls;
  // const {
  //   data: accounts,
  //   fetching,
  //   fetchURL,
  // } = useFetchURL({
  //   ...{ url, mapFunction: convertToTreeData, dependencyArray: [] },
  // });

  if (fetchAll || !AutoOptions?.center) return <></>;

  return (
    <AccountingRPT
    // <AccountMovement
      {...{
        AutoOptions: AutoOptions?.center ? AutoOptions : defaultAutos,
        // accounts: accounts?.length > 0 ? accounts : [],
      }}
    />
  );
}
